import { FC, ReactNode } from 'react'

import styled from 'styled-components'

import { PrimaryHint } from 'src/Components/PrimaryHint'
import { MAX_MOBILE_WIDTH, variables } from 'src/Styled/variables'

const StatsContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  row-gap: 4px;
  justify-content: space-between;
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  padding-left: 1px;
  color: ${({ theme }) => theme.color.darkGrey};
  background-color: ${({ theme }) => theme.color.white};
  flex-grow: 1;
`

const Label = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    max-width: 50px;
  }

  span {
    flex-shrink: 0;
    font-size: ${variables.fontSize14};
    line-height: 150%;
  }
`

const Value = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize18};
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const HintContainer = styled.div`
  position: absolute;
  right: -25px;
  top: 4px;
`

const NameWrapper = styled.div`
  position: relative;
`

export interface StatsSectionInnerProps {
  title: string
  value?: string | number
  hintText?: ReactNode
  className?: string
}

export const StatsSectionInner: FC<StatsSectionInnerProps> = ({
  title,
  value,
  hintText,
  className,
}) => (
  <StatsContainer className={className}>
    <Label>
      <NameWrapper>
        <span>{title}</span>
        {hintText && (
          <HintContainer>
            <PrimaryHint children={hintText} />
          </HintContainer>
        )}
      </NameWrapper>
    </Label>
    <Value>{value}</Value>
  </StatsContainer>
)
